export const PACKAGE_VERSION = "0.52.0";
//# sourceMappingURL=package-version.js.map